import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import DataProvider from "./utilities/context/DataProvider";
import RegistrationAndPurchase from "./screens/RegistrationAndPurchase";
import Products from "./screens/Products";
import Register from "./screens/Register";
import Login from "./screens/Login";
import PaymentProcessed from "./screens/PaymentProcessed";
import './App.css';
import {Navigate} from "react-router";
import Dashboard from "./screens/Dashboard";
import UserPanel from "./components/Dashboard/UserPanel";
import Upgrade from "./screens/Dashboard/Upgrade";
import Purchase from "./screens/Dashboard/Purchase";
import TransactionPage from "./screens/Dashboard/TransactionPage";
import ScrollToTop from "./components/Utility/ScrollToTop";
import Forgotten from "./screens/Forgotten";

function App() {
    return (
        <div className="App">
            <DataProvider>
                <Router basename={'/app/'}>
                    <ScrollToTop />
                    <Routes>
                        <Route index element={<Login/>} />
                        <Route path="login" element={<Login />} />
                        <Route path="forgotten" element={<Forgotten />} />
                        <Route path="signup" element={<RegistrationAndPurchase />} />
                        <Route path="register" element={<Register />} />
                        <Route path="products" element={<Products />} />
                        <Route path="dashboard" element={<Dashboard />}>
                            <Route index element={<UserPanel/>} />
                            <Route path="" element={<UserPanel />} />
                            <Route path="upgrade" element={<Upgrade/>} />
                            <Route path="subscriptions" element={<Purchase />} />
                            <Route path="purchase" element={<TransactionPage />} />
                        </Route>
                        <Route path="payment_recap" element={<PaymentProcessed />} />
                        <Route path="*" element={<Navigate to="/signup" replace />} />
                    </Routes>
                </Router>
            </DataProvider>
        </div>
    );
}

export default App;
